import { useTranslation } from "react-i18next";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AlertCircle, RefreshCw, ArrowLeft } from "lucide-react";
import { useContractorCardContext } from "../context";

export const ContractorCardAlert = () => {
  const { t } = useTranslation();
  const { clearError, refreshContractorCard, errorState } =
    useContractorCardContext();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <Card className="w-full max-w-md">
        <CardContent className="pt-6">
          <div className="text-center">
            <AlertCircle className="h-16 w-16 text-red-500 mx-auto mb-4" />
            <h2 className="text-2xl font-bold mb-2">
              {t("errors.genericTitle")}
            </h2>
            <p className="text-gray-600 mb-6">
              {errorState.error?.message || t("errors.genericMessage")}
            </p>
            <Button
              onClick={errorState.isQuery ? refreshContractorCard : clearError}
              variant="outline"
              className="w-full"
            >
              {errorState.isQuery ? (
                <RefreshCw className="h-4 w-4 mr-2" />
              ) : (
                <ArrowLeft className="h-4 w-4 mr-2" />
              )}
              {errorState.isQuery ? t("common.refresh") : t("common.back")}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
